module.exports = __webpack_public_path__ + "img/cbr-quest-down.bf1dd3a1.svg";